export const NEW_CAMPAIGN_UNITS = 'NEW_CAMPAIGN_UNITS'
export const NEW_CAMPAIGN_PREVIEW_UNITS = 'NEW_CAMPAIGN_PREVIEW_UNITS'
